import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Roadblockschology() {
  return (
    <section className="roadblock-schology p-100">
      <Container>
        <Row className="mb-4 mb-md-5">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={9}
            xxl={8}
            className="m-auto text-center"
          >
            <h2 style={{ color: "#111322" }}>
              The <span className="purple-box">Roadblocks</span> We Conquered to
              Build a Seamless School Ecosystem
            </h2>
          </Col>
        </Row>
        <Row>
          <Col xs={12} md={6} lg={5} xl={5} xxl={5} className="my-auto">
            <div className="roadblock-box">
              <div className="roadblock-flex">
                <div className="roadblock-num">01</div>
                <div className="roadblock-para">
                  <p>
                    The absence of a unified digital platform for schools,
                    leading to fragmented systems and communication gaps.
                  </p>
                </div>
              </div>
            </div>
            <div className="roadblock-box">
              <div className="roadblock-flex">
                <div className="roadblock-num">02</div>
                <div className="roadblock-para">
                  <p>
                    Managing diverse user roles across different schools,
                    ensuring that data privacy and user accessibility were
                    maintained.
                  </p>
                </div>
              </div>
            </div>
            <div className="roadblock-box">
              <div className="roadblock-flex">
                <div className="roadblock-num">03</div>
                <div className="roadblock-para">
                  <p>
                    Developing a scalable, multi-tenant platform that could
                    support the growth of multiple schools without compromising
                    performance.
                  </p>
                </div>
              </div>
            </div>
          </Col>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="text-center offset-lg-1"
          >
            <StaticImage
              src="../../../images/case-studies/schology/roadblock-img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={809}
              height={571}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Roadblockschology;
